import React, { Component } from 'react'
import FormViewer from '../../components/FormViewer'
import ButtonAnimated from '../../components/buttons/ButtonAnimated'
import HttpServices from '../../utils/Http.services'
import store from '../../stores/storeConfig'
import { addNotif } from '../../stores/actionsList'

export default class LoginReferralCheck extends Component {
    state = {
        headers: [
            { key: 'referral', type: 'TextInput', information: { label: 'referral', placeholder: '{{lang}}insertRefferal', autoFocus: true, required: true } },
        ]
    }
    postRefferal = () => {
        console.log('first')
        let data = this.form.getForm()
        if (data) {
            HttpServices.request('checkReferral', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                // console.log('fetchResult',fetchResult)
                if (fetchResult.pass) {
                    this.props.changeStage('info')
                    return
                }
                store.dispatch(addNotif({ type: 'error', title: '{{lang}}errors.invalidReferralCode', description: 'invalid referral code' }))
            })
        }
    }
    render() {
        return (
            <div className='w-100 px-2 py-2 text-normal'>
                <p>Use Referral To Make Account :</p>
                <div className='flexcc py-2'>
                    <FormViewer ref={el => this.form = el} initData={this.props.initData} headers={this.state.headers} errors={this.state.errors} inputClass={'modern-input'} />
                    <ButtonAnimated
                        icon={'/assets/icons/arrow-right-white.svg'}
                        bg={this.props.textColor}
                        title={'Submit'}
                        onClick={this.postRefferal}
                        isLoading={this.state.isLoading}
                    />
                </div>

            </div>
        )
    }
}
